import { Typography } from 'react-md';
import { useAppSelector } from '@app/hooks';
import { selectOrderProducts } from '@modules/order';
import { selectModelById, selectModelsDict, selectSelectedModels } from '@modules/models';
import { customVariables as CV } from '@utils';

import styles from './line-items-rfq-summary.module.scss';

export function LineItemsRfqSummary() {
    const products = useAppSelector(selectOrderProducts);
    const modelsIds = useAppSelector(selectSelectedModels);
    const hasAllProducts = products?.length === modelsIds?.length;
    const { RfqModelWithErrorId } = CV;
    const model = useAppSelector(selectModelById(RfqModelWithErrorId));
    const hasModel = !!RfqModelWithErrorId && !!model;

    return (
        <div className="base-paddings">
            <Typography type="headline-5">RFQ Summary</Typography>
            <Typography className="margin-top" type="headline-6">
                Success:
            </Typography>
            <ul className="no-margins no-paddings small-margin-top">
                {products?.map(({ id, model_title, count, material_title }) => (
                    <li key={id}>
                        <Typography className={styles.key} component="span" type="body-2">
                            ✅ {model_title}:{' '}
                        </Typography>
                        <Typography component="span" type="body-2">
                            requested {count} pcs. in {material_title}
                        </Typography>
                    </li>
                ))}
            </ul>
            {!hasAllProducts && hasModel && (
                <>
                    <Typography className="margin-top" type="headline-6">
                        Failed:
                    </Typography>
                    <ul className="no-margins no-paddings small-margin-top">
                        <li>
                            <Typography className={styles.key} component="span" type="body-2">
                                ⚒️ {model.title}:{' '}
                            </Typography>
                            <Typography component="span" type="body-2">
                                requested 10 pcs. in Aluminum 6061
                            </Typography>
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
}
